import React, { forwardRef } from 'react'
import { Button } from '@mui/material'

const buttonStyles = { whiteSpace: 'nowrap' }

const AppButton = forwardRef(function AppButton({ variant = 'contained', size = 'large', sx, ...props }, ref) {
    return (
        <Button
            ref={ref}
            variant={variant}
            size={size}
            sx={[buttonStyles, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
            {...props}
        />
    )
})

export default AppButton
